import React, { useEffect } from 'react'
import aos from 'aos'

const Client = () => {
    useEffect(() => {
        aos.init({ duration: 2000 });
    }, [])

    const cliData = [
        {
            id: 1,
            name: "Marvin Laurent",
            loc: "USA"
        },
        {
            id: 2,
            name: "Adnan Saleem",
            loc: "Ukraine"
        },

        {
            id: 3,
            name: "Conor Pollock",
            loc: "Egypt"
        },
        {
            id: 4,
            name: "Qasim Zubair",
            loc: "Turkey"
        },
        {
            id: 5,
            name: "Emely Soto",
            loc: "Ethiopia"
        },
        {
            id: 6,
            name: "Zhen ZhuiMing",
            loc: "Singapore"
        },
        {
            id: 7,
            name: "Saige Wolf",
            loc: "Australia"
        },
        {
            id: 8,
            name: "Shreek Pawar",
            loc: "India"
        },
        {
            id: 9,
            name: "Rosa Morton",
            loc: "USA"
        },
        {
            id: 10,
            name: "Batuhan Ulker",
            loc: "Israel"
        },

    ]
    return (
        <>
            {/* <!-- Start Cient Area --> */}
            <div id="client" className="rn-client-area rn-client-style-2 rn-section-gap section-separator">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div data-aos="fade-up" data-aos-duration="500" data-aos-delay="100" data-aos-once="true" className="section-title text-center">
                                <span className="subtitle">Visit my Client</span>
                                <h2 className="title">Our Trusted Client</h2>
                            </div>
                            <div className="skill-style-1">
                                <div className="client-card">

                                    {cliData.map((val, ind) => {
                                        return (
                                            <>

                                                {/* <!-- Start Single Brand  --> */}
                                                <div data-aos="fade-up" data-aos-duration="500" data-aos-delay="100" data-aos-once="true" className="main-content">
                                                    <div className="inner text-center">
                                                        <div className="client-name">
                                                            <a href="#">{val.name}</a>
                                                        </div>
                                                        <div className="seperator"></div>
                                                        <div className="client-name"><span><a href="#">{val.loc}</a></span>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* <!-- End Single Brand  --> */}      </>
                                        )
                                    })}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- end Cient Area --> */}



        </>
    )
}

export default Client